import { map } from 'rxjs/operators';
// Constants / Utils
import { convertNestedStringToBoolean } from 'NewAngular/utils/state-utils';
import { DEFAULT_ERROR_MSG } from 'HypotheticalsApp/apps/hypotheticals-app/constants';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class SavedAnalysisPlanService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    createItem(analysisPlanParams, itemName) {
        const postParams = { state: analysisPlanParams, name: itemName };
        const postUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_COLLECTION);
        return this.ajaxService.postJsonDataObserveBody(postUrl, postParams).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    deleteItem(analysisPlanId) {
        const urlParams = { analysisPlanId };
        const deleteUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_ITEM, urlParams);
        return this.ajaxService.deleteDataObserveBody(deleteUrl);
    }
    getErrorMessage(error) {
        let errorMessage;
        switch (error.status) {
            case 404:
                errorMessage = 'Scenario not found, please try again.';
                break;
            case 403:
                errorMessage = error.error?.error_message ?? DEFAULT_ERROR_MSG;
                break;
            case 409:
                errorMessage = 'Cannot save with duplicate name, please try again.';
                break;
            default:
                errorMessage = DEFAULT_ERROR_MSG;
                break;
        }
        return errorMessage;
    }
    getItem(analysisPlanId) {
        const urlParams = { analysisPlanId };
        const getUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_ITEM, urlParams);
        return this.ajaxService.getDataObserveBody(getUrl).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    getItems(getParams) {
        const getUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_COLLECTION);
        return this.ajaxService.getDataObserveBody(getUrl, getParams).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    updateItem(analysisPlanId, putParams) {
        const urlParams = { analysisPlanId };
        const putUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.ANALYSIS_PLAN_ITEM, urlParams);
        return this.ajaxService.putJsonDataObserveBody(putUrl, putParams).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
}
SavedAnalysisPlanService.ɵfac = function SavedAnalysisPlanService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedAnalysisPlanService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SavedAnalysisPlanService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedAnalysisPlanService, factory: SavedAnalysisPlanService.ɵfac, providedIn: 'root' });
